import { render, staticRenderFns } from "./DadosPerfil.vue?vue&type=template&id=5dc03e97"
import script from "./DadosPerfil.vue?vue&type=script&lang=js"
export * from "./DadosPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports